import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import ClockBack from './back-manager/clock_back.js'; // 測試用

// 懶加載頁面
const Test = lazy(() => import("./test"));
const Home = lazy(() => import("./Home"));
const HomeBackTest = lazy(() => import("./Home_back"));
const Clock = lazy(() => import("./clock"));
const Repair = lazy(() => import("./repair"));
const RepairForm = lazy(() => import("./repair_form"));
const RepaymentExport = lazy(() => import("./repayment_export"));
const Repayment = lazy(() => import("./repayment"));
const RepaymentForm = lazy(() => import("./repayment_form"));
const RepaymentRecord = lazy(() => import("./repayment_record"));
const Wish = lazy(() => import("./wish"));
const Absence = lazy(() => import("./absence"));
const AbsenceForm = lazy(() => import("./absence_form"));
const Salary = lazy(() => import("./salary"));
const SalaryLaw = lazy(() => import("./salarylaw"));
const Schedule = lazy(() => import("./schedule"));
const ScheduleAdd = lazy(() => import("./scheduleadd"));
const WorkOvertimeForm = lazy(() => import("./work_overtime_form"));
const WorkMissionForm = lazy(() => import("./work_mission_form"));
const WorkClockForm = lazy(() => import("./work_clock_form"));

// Manager 子路由
const ManagerDashboard = lazy(() => import("./back-manager/home_back"));
const Manager = lazy(() => import("./back-manager/manager_back"));
const ManagerAdd = lazy(() => import("./back-manager/manager_back_add"));
const Employee = lazy(() => import("./back-manager/employee_back"));
const EmployeeAdd = lazy(() => import("./back-manager/employee_back_add"));
const JobManagement = lazy(() => import("./back-manager/job_management"));
const AbsenceBack = lazy(() => import("./back-manager/absence_back"));
const AbsenceCard = lazy(() => import("./back-manager/absence_card"));
const AbsenceEdit = lazy(() => import("./back-manager/absence_back_edit"));
const AbsenceCheck = lazy(() => import("./back-manager/absence_back_check"));
const LeaveRules = lazy(() => import("./back-manager/LeaveRules"));

const ClockBack = lazy(() => import("./back-manager/clock_back"));
const ClockSearch = lazy(() => import("./back-manager/clock_back_search"));
const ClockLocation = lazy(() => import("./back-manager/clock_back_location"));
const ClockBackExport = lazy(() => import("./back-manager/clock_back_export"));
const SalaryBack = lazy(() => import("./back-manager/salary_back"));
const SalaryBackEdit = lazy(() => import("./back-manager/salary_back_edit"));
const RepaymentBack = lazy(() => import("./back-manager/repayment_back"));
const RepaymentBackSearch = lazy(() => import("./back-manager/repayment_back_search"));
const RepaymentBackExport = lazy(() => import("./back-manager/repayment_back_export"));
const ScheduleBack = lazy(() => import("./back-manager/schedule_back"));
const ScheduleBackAdd = lazy(() => import("./back-manager/schedule_back_add"));
const WishBack = lazy(() => import("./back-manager/wish_back"));
const RepairBack = lazy(() => import("./back-manager/repair_back"));
const ProjectBack = lazy(() => import("./back-manager/project_back"));


// Manager Layout
const ManagerLayout = () => <Outlet />;


function App() {
  return (
    <Router>
      {/* <Suspense fallback={<div>Loading...</div>}></Suspense> */}
      <Suspense>
        <div className="App" style={{ fontFamily: "'PingFang TC', 'Noto Sans TC', sans-serif" }}>
          <Routes>
            {/* 頂層路由 */}
            <Route path="/" element={<Home />} />
            <Route path="/back/test/test" element={<Test />} />
            <Route path="/back/test" element={<HomeBackTest />} />
            <Route path="/clock" element={<Clock />} />
            <Route path="/repair" element={<Repair />} />
            <Route path="/repair_form" element={<RepairForm />} />
            <Route path="/repayment_export" element={<RepaymentExport />} />
            <Route path="/repayment" element={<Repayment />} />
            <Route path="/repayment_form" element={<RepaymentForm />} />
            <Route path="/repayment_record" element={<RepaymentRecord />} />
            <Route path="/wish" element={<Wish />} />
            <Route path="/leave" element={<Absence />} />
            <Route path="/leave_form" element={<AbsenceForm />} />
            <Route path="/salary" element={<Salary />} />
            <Route path="/salarylaw" element={<SalaryLaw />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/scheduleadd" element={<ScheduleAdd />} />
            <Route path="/work_overtime_form" element={<WorkOvertimeForm />} />
            <Route path="/work_mission_form" element={<WorkMissionForm />} />
            <Route path="/work_clock_form" element={<WorkClockForm />} />

            {/* Manager 嵌套路由(Nested Routes) */}
            <Route path="/manager" element={<ManagerLayout />}>
                <Route index element={<ManagerDashboard />} />

                {/* Permission 子模組 */}
                <Route path="permission">
                  <Route index element={<Manager />} />
                  <Route path="add" element={<ManagerAdd />} />
                </Route>

                {/* Employee 子模組 */}
                <Route path="employee">
                  <Route index element={<Employee />} />
                  <Route path="add" element={<EmployeeAdd />} />
                  <Route path="job_management" element={<JobManagement />} />
                </Route>
                
                {/* Absence 子模組 */}
                <Route path="leave_back">
                  <Route index element={<AbsenceBack />} />
                  <Route path="card" element={<AbsenceCard />} />
                  <Route path="edit" element={<AbsenceEdit />} />
                  <Route path="check" element={<AbsenceCheck />} />
                  <Route path="leave-rules" element={<LeaveRules />} />
                </Route>
                
                
                {/* Clock 子模組 */}
                <Route path="clock_back">
                  <Route index element={<ClockBack />} />
                  <Route path="search" element={<ClockSearch />} />
                  <Route path="location" element={<ClockLocation />} />
                  <Route path="add" element={<WorkClockForm />} />
                  <Route path="export-excel-clock" element={<ClockBackExport />} />
                </Route>

                {/* Salary 子模組 */}
                <Route path="salary_back">
                  <Route index element={<SalaryBack />} />
                  <Route path="edit" element={<SalaryBackEdit />} />
                </Route>
                
                {/* Repayment 子模組 */}
                <Route path="repayment_back">
                  <Route index element={<RepaymentBack />} />
                  <Route path="search" element={<RepaymentBackSearch />} />
                  <Route path="export-excel-repayment" element={<RepaymentBackExport />} />
                </Route>

                {/* Schedule 子模組 */}
                <Route path="schedule_back">
                  <Route index element={<ScheduleBack />} />
                  <Route path="add" element={<ScheduleBackAdd />} />
                </Route>

                {/* Wish 子模組 */}
                <Route path="wish_back">
                  <Route index element={<WishBack />} />
                </Route>
                
                {/* Repair 子模組 */}
                <Route path="repair_back">
                  <Route index element={<RepairBack />} />
                </Route>

                {/* Project 子模組 */}
                <Route path="project_back">
                  <Route index element={<ProjectBack />} />
                </Route>
                

              </Route>
          </Routes>
        </div>
      </Suspense>
    </Router>
  );
}

export default App;
